import calculationService from '../../api/calculationService'


// initial state
const state = {
  id: null,
  type: null,
  calculation: null,

  initParams: {},
  selectedOperation: null,
  result: {}
}

// getters
const getters = {
  // operations: state => state.operations
}

// actions
const actions = {
  fetchInitParams({ commit, state }, calcId) {
    return calculationService.getRoomCalculationInitParams(calcId || state.id)
        .then(initParams => commit('SET_INIT_PARAMS', initParams));
  },

  fetchCalculation({ commit, state }, calculationId) {
    return calculationService.getCalculation('room', calculationId)
      .then(calculation => commit('SET_CALCULATION', calculation))
  },

  updateSelectedOperation({ commit, state }, operationId) {
    state.calculation.selectedOperationId = operationId;
    return calculationService.updateCalculation('room', state.calculation.calculationId, state.calculation)
      .then(calculation => commit('SET_CALCULATION', calculation))
  }
}

// mutations
const mutations = {
  SET_ID(state, id) {
    state.id = id
  },
  SET_TYPE(state, type) {
    state.type = type
  },
  SET_CALCULATION(state, calculation) {
    state.calculation = calculation
  },



  SET_SELECTED_OPERATION(state, operation) {
    state.selectedOperation = operation
  },
  SET_INIT_PARAMS(state, initParams) {
    state.initParams = initParams
  },
  SET_RESULT(state, result) {
    state.result = result
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calculation.js